import ApiService from "@/core/services/ApiService";

const endpoints = {
    default: {
        auth_change_password: "auth/change-password",
        library_directory: "directory",
        library_directory_tree: "directory/tree",
        library_directory_export_videos: "directory/export/videos",
        library_video: "video",
        library_video_group: "video/group",
        trash: "trash",
        trash_recover: "trash/recover",
    },
    developer: {
        developer_customer: "/customer",
        developer_customer_self_login: "/customer/self-login",
        developer_company: "/customer/company",
        developer_group: "/customer/group",
        cdn_server: "/cdn/storage",
        video_management_downloader: "/video-management/downloader",
        video_management_converter: "/video-management/converter",
        video_management_migrator: "/video-management/migrator",
    }
}

class EndpointService {
    static activeEndpoints = endpoints;
    static apiConfig = {
        default: process.env.VUE_APP_API_PATH,
        developer: process.env.VUE_APP_API_DEVELOPER_PATH,
    };

    static {
        this.setActiveEndpoints()
    }

    static get(endpointKey, groupKey = 'default') {
        ApiService.setBaseUrl(this.apiConfig[groupKey] ?? process.env.VUE_APP_API_URL);
        return (this.activeEndpoints[groupKey] && this.activeEndpoints[groupKey][endpointKey]) ? this.activeEndpoints[groupKey][endpointKey] : null;
    }

    static setActiveEndpoints(groupKey) {
        let groups = ['default', groupKey];

        for (let key in endpoints) {
            if (groups.includes(key)) {
                this.activeEndpoints[key] = endpoints[key];
            }
        }
    }

}

export default EndpointService;
